import type { ActivityStatus } from "../entities/activities"

export default function isDraggableStatus(status: ActivityStatus) {
  const isDraggableStatus = status === "pending" || status === "rescheduled" || status === "failed"

  return isDraggableStatus
}
